import { defineComponent as s, openBlock as r, createBlock as u, unref as c, withCtx as i, renderSlot as d, normalizeProps as a, guardReactiveProps as n, createElementBlock as m, createCommentVNode as b } from "vue";
import { RevModalBase as f } from "@ds/components/ModalBase";
const k = {
  key: 0,
  class: "pt-24"
}, B = /* @__PURE__ */ s({
  name: "RevDialog",
  __name: "Dialog",
  props: {
    name: {},
    title: { default: "" },
    closeButtonLabel: { default: () => {
    } },
    hasPadding: { type: Boolean, default: !0 },
    to: { default: "body" },
    defer: { type: Boolean, default: !1 },
    backdropZIndex: { default: () => {
    } },
    backgroundColor: { default: "mid" },
    disableCloseOnBackdropClick: { type: Boolean, default: !1 },
    shouldKeepAlive: { type: Boolean, default: !1 }
  },
  emits: ["open", "close"],
  setup(e) {
    return (l, t) => (r(), u(c(f), {
      "backdrop-background-color": "hi",
      "backdrop-z-index": e.backdropZIndex,
      "background-color": e.backgroundColor,
      class: "rounded-t-lg md:rounded-b-lg md:bottom-auto md:left-1/2 md:top-1/2 md:w-640 md:-translate-x-1/2 md:-translate-y-1/2",
      "close-button-label": e.closeButtonLabel,
      defer: e.defer,
      "disable-close-on-backdrop-click": e.disableCloseOnBackdropClick,
      "has-padding": e.hasPadding,
      name: e.name,
      "should-keep-alive": e.shouldKeepAlive,
      title: e.title,
      to: e.to,
      onClose: t[0] || (t[0] = (o) => l.$emit("close", o)),
      onOpen: t[1] || (t[1] = (o) => l.$emit("open"))
    }, {
      body: i(({ close: o }) => [
        d(l.$slots, "body", a(n({ close: o }))),
        l.$slots.footer ? (r(), m("div", k, [
          d(l.$slots, "footer", a(n({ close: o })))
        ])) : b("", !0)
      ]),
      trigger: i(({ open: o }) => [
        d(l.$slots, "trigger", a(n({ open: o })))
      ]),
      _: 3
    }, 8, ["backdrop-z-index", "background-color", "close-button-label", "defer", "disable-close-on-backdrop-click", "has-padding", "name", "should-keep-alive", "title", "to"]));
  }
});
export {
  B as default
};
